import { ITeacher } from 'models';
import moment from 'moment-timezone';
import { ongoingFormFields } from 'parent-portal/forms/JobForm';
import { daysOfTheWeek } from 'shared/Dates';

function normalizeCredentials(credentials: ITeacher['credentials']) {
    const experience = `experience: ${credentials.experience.split(' ')[0]}`;
    const education = credentials.education.map((ed: string) => `education: ${ed}`);

    return Object.values({ education, experience }).flat();
}

export function teacherToSpotlightWorkerApiObject(worker: ITeacher) {
    return {
        id: worker.id,
        name: worker.name,
        pictureUrl: worker.pictureUrl,
        bio: worker.bio,
        credentials: normalizeCredentials(worker.credentials),
    };
}

export function timeslotToJobTimesApiObject(timeslot: { upper: string; lower: string; timezone: string }) {
    return {
        start: moment(timeslot.lower),
        end: moment(timeslot.upper),
        slots: 1,
        timezone: timeslot.timezone,
    };
}

export function timeslotToDaysOfWeekApiObject(timeslot: { upper: string; lower: string; timezone: string }) {
    const dayOfWeek = daysOfTheWeek[new Date(timeslot.lower).getDay()];
    return {
        ...ongoingFormFields.daysOfTheWeek,
        [dayOfWeek]: {
            selected: true,
            start: moment(timeslot?.lower),
            end: moment(timeslot?.upper),
            slots: 1,
            timezone: timeslot?.timezone,
        },
    };
}
